import React, { useMemo } from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import classNames from 'classnames';
import { image } from '../../../utils/data/baseUrl';
import { useDevice } from '../../../hooks/useDevice';

const GameTutorialModal = React.forwardRef(function GameTutorial(
  { description, descriptionM, descriptionD, images, type, className, callback },
  ref,
) {
  const { closeModal, id } = useModal();
  const device = useDevice();

  const descriptionText = useMemo(() => {
    if (type === 'jumper') return device === 'mobile' ? descriptionM : descriptionD;
    return description;
  }, [description, type, device]);

  const close = () => {
    closeModal({ id });
    callback?.();
  };

  return (
    <CustomModal
      className={'custom-modal_fullpage custom-modal_gTutorial'}
      animation={['fade']}
      styles={'height:'}
      horizontalPosition={''}
    >
      <div
        className={classNames('game-tutorial', className, { [`game-tutorial_${type}`]: type })}
        ref={ref}
        onClick={close}
        onKeyDown={close}
      >
        <div className={'game-tutorial__bg'} />
        <div className={'game-tutorial__text'}>{safeHTML(descriptionText)}</div>
        {images && (
          <>
            <div className={'game-tutorial__images _desktop'}>
              {images.map(({ img }, index) => {
                return (
                  <div
                    key={`game-tutorial__image-${id}`}
                    className={`game-tutorial__image game-tutorial__image_${index + 1}`}
                  >
                    <img src={image(img)} alt='arrow' />
                  </div>
                );
              })}
            </div>
            <div className={'game-tutorial__images _mobile'}>
              {images.map(({ imgM }, index) => {
                return (
                  <div
                    key={`game-tutorial__image-${id}`}
                    className={`game-tutorial__image game-tutorial__image_${index + 1}`}
                  >
                    <img src={image(imgM)} alt='arrow' />
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </CustomModal>
  );
});
export default GameTutorialModal;
GameTutorialModal.propTypes = {};
